import Vue from 'vue'
import {
  ANCHOR_MARGIN, anchoredTop, getLastAnchorY, installClickAnchor,
  isEmbeddedInFrame, scrollFrameToRect
} from '../mixins/ltiFrameMixin'

/**
 * Coloca los diálogos de $confirm (vue-confirm-dialog) a la altura del punto donde el
 * usuario hizo clic, manteniéndolos centrados horizontalmente.
 *
 * El overlay del paquete es `position: fixed` con centrado por flexbox, así que se
 * coloca en el centro del viewport del iframe. Como changeHeightIFrame (main.js)
 * redimensiona el iframe a la altura del contenido, ese viewport es todo el iframe:
 * en un iframe de 3000px el diálogo cae en y≈1500, casi siempre fuera de lo que el
 * usuario está mirando, y este solo ve la página atenuada sin diálogo a la vista.
 *
 * Solo actúa dentro de un iframe. En la vista de administración, que nunca va
 * embebida, el diálogo se sigue centrando como siempre.
 */

function anchorDialog (anchorY) {
  const overlay = document.getElementById('vueConfirm')
  if (!overlay) return
  const box = overlay.querySelector('.vc-container')
  if (!box) return

  // La clase va antes de medir: al pasar a position: absolute cambia el ancho
  // resuelto del diálogo, que es `width: auto` en los estilos de la aplicación.
  overlay.classList.add('vc-anchored')
  const dialog = box.getBoundingClientRect()

  // En horizontal, centrado: el iframe ocupa todo el ancho y no tiene scroll
  // horizontal, así que el centro del iframe es el centro de la pantalla.
  box.style.left = Math.max((overlay.clientWidth - dialog.width) / 2, ANCHOR_MARGIN) + 'px'
  // En vertical, a la altura del clic, sin salirse del iframe.
  box.style.top = anchoredTop(anchorY, dialog.height, overlay.clientHeight) + 'px'

  nudgeIntoView(box)
}

/**
 * Empujón mínimo para que el diálogo se vea entero: 'nearest' no mueve nada si ya
 * cabe en la ventana y, si queda cortado por un borde, desplaza lo justo.
 */
function nudgeIntoView (box) {
  const dialog = box.getBoundingClientRect()
  scrollFrameToRect(
    dialog.left + window.pageXOffset, dialog.top + window.pageYOffset,
    dialog.width, dialog.height, 'nearest'
  )
}

export default function installAnchoredConfirm () {
  // Seguimiento del clic, compartido con el anclado de los b-modal (ltiFrameMixin).
  installClickAnchor()

  const original = Vue.prototype.$confirm
  const anchored = params => {
    const result = original(params)
    const lastAnchorY = getLastAnchorY()
    if (isEmbeddedInFrame() && lastAnchorY !== null) {
      // nextTick para que el v-if del diálogo haya insertado ya el DOM. El
      // setTimeout no es requestAnimationFrame a propósito: Chrome estrangula el
      // rAF de los iframes que quedan fuera de pantalla, que es justo la situación
      // que estamos corrigiendo, y la callback puede no ejecutarse nunca.
      // getBoundingClientRect fuerza el cálculo de estilos, así que no hace falta
      // esperar a un repintado para medir.
      Vue.nextTick(() => window.setTimeout(() => anchorDialog(lastAnchorY), 0))
    }
    return result
  }
  // El paquete cuelga close() de la propia función, hay que conservarlo.
  anchored.close = original.close
  Vue.prototype.$confirm = anchored
  Vue.$confirm = anchored
}



// WEBPACK FOOTER //
// ./src/plugins/anchoredConfirm.js